import React, { useEffect } from 'react';
import { StyleSheet, View, Image, Platform, KeyboardAvoidingView } from 'react-native';
import { ErrorMessage } from '~/components/core';
import { useAppDispatch, useAppSelector, useStyles } from '~/hooks';
import { FONT_SIZE_XXXL, spacing } from '~/constants';
import { appSettingsSelector, userAuthSelector } from '~/state/selectors';
import { loginWithSessionId } from '~/state/reducers/userAuthSlice';
import { scaleSize, scaleSizeMobile } from '~/constants/scale';
import { Theme } from '~/theme';
import config from '~/config';
import { SvgUri } from 'react-native-svg';
import { useBrowserLanguage } from '~/hooks/useBrowserLanguage';
import { useRoute } from '@react-navigation/native';

export default function LoginSessionIdForm() {
    const route: any = useRoute();
    const sessionId: string = route.params?.s;

    const dispatch = useAppDispatch();
    const { errorMessage } = useAppSelector(userAuthSelector);
    const { colorScheme, language } = useAppSelector(appSettingsSelector);
    const maxWidth: number = 600;
    const styles = useStyles(stylesGenerator, { maxWidth });
    useBrowserLanguage();

    useEffect(() => {
        if (sessionId) {
            dispatch(loginWithSessionId({ sessionId, language: language || 'en' }));
        }
    }, [dispatch, sessionId, language]);

    const logoUri =
        'https://' +
        config.EXTERNAL_SOURCES_URL +
        'mobileplatform/images/brand/' +
        config.BRAND_NAME +
        '/home_logo_' +
        colorScheme +
        '.svg?1';

    return (
        <KeyboardAvoidingView style={styles.container} behavior={'height'}>
            <View style={styles.logoContainer}>
                {Platform.OS === 'web' ? (
                    <Image source={{ uri: logoUri }} style={styles.logoStyle} resizeMode="contain" />
                ) : (
                    <SvgUri width={'60%'} style={styles.logoStyle} uri={logoUri} />
                )}
            </View>
            <ErrorMessage text={errorMessage} visible={!!errorMessage} />
        </KeyboardAvoidingView>
    );
}

const stylesGenerator = (theme: Theme, custom?: { maxWidth: number }) =>
    StyleSheet.create({
        logoStyle: {
            width: config.HOME_LOGO_SIZE_IN_PERCENT,
            height: '100%',
            maxWidth: scaleSizeMobile(custom?.maxWidth),
            maxHeight: scaleSizeMobile(custom?.maxWidth),
        },
        logoContainer: { height: '50%', justifyContent: 'center', alignItems: 'center' },
        container: {
            flex: 1,
            justifyContent: 'space-between',
            alignSelf: 'center',
            maxWidth: custom?.maxWidth,
            paddingHorizontal: scaleSize(12, custom?.maxWidth),
            width: '100%',
            height: '100%',
            maxHeight: '100%',
        },
        title: {
            fontSize: FONT_SIZE_XXXL,
            fontWeight: '600',
            alignSelf: 'center',
            marginBottom: scaleSize(spacing.LARGE, custom?.maxWidth),
        },
    });
